import React from 'react'
import { Box, Container, Typography } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import ForgotPasswordForm from './components/Form'

import useStyles from './styles'

const ForgotPassword = ({
  whiteColor = false,
  email = '',
  enableRedirect = true,
  setClose = () => {},
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Container maxWidth="sm" fullWidth>
        <Typography
          variant="h3"
          color="textPrimary"
          className={clsx(classes.title, classes.colorBlue, {
            [classes.colorWhite]: whiteColor,
          })}
        >
          Olá!
        </Typography>
        <Typography
          variant="subtitle1"
          className={clsx(classes.subtitle, classes.colorBlue, {
            [classes.colorWhite]: whiteColor,
          })}
        >
          Digite seu e-mail para recuperar a senha
        </Typography>
        <Box mt={3}>
          <ForgotPasswordForm
            whiteColor={whiteColor}
            email={email}
            enableRedirect={enableRedirect}
            setClose={setClose}
          />
        </Box>
      </Container>
    </Box>
  )
}

ForgotPassword.propTypes = {
  whiteColor: PropTypes.bool,
  email: PropTypes.string,
  enableRedirect: PropTypes.bool,
  setClose: PropTypes.func,
}

export default ForgotPassword
